var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGovernment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EDF2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 34h2m18 0h-2m0 0v-7m0 7h-4m-12 0v-7m0 7h4m0-11h-4v4m4-4v-3h4m-4 3h8m0 0h4v4m-4-4v-3h-4m0 0v-3m0 0v-3h4v3h-4zm-8 10h4m12 0h-4m0 0v7m0-7h-4m4 7h-4m0 0v-7m0 7h-4m4-7h-4m0 0v7",
    stroke: "#5782F2",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNFREYyRkUiLz4KPHBhdGggZD0iTTE0IDM0SDE2TTM0IDM0SDMyTTMyIDM0VjI3TTMyIDM0SDI4TTE2IDM0VjI3TTE2IDM0SDIwTTIwIDIzSDE2VjI3TTIwIDIzVjIwSDI0TTIwIDIzSDI4TTI4IDIzSDMyVjI3TTI4IDIzVjIwSDI0TTI0IDIwVjE3TTI0IDE3VjE0SDI4VjE3SDI0Wk0xNiAyN0gyME0zMiAyN0gyOE0yOCAyN1YzNE0yOCAyN0gyNE0yOCAzNEgyNE0yNCAzNFYyN00yNCAzNEgyME0yNCAyN0gyME0yMCAyN1YzNCIgc3Ryb2tlPSIjNTc4MkYyIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgGovernment as ReactComponent };